window.openPriceBreakup = function () {
  const overlay = document.getElementById('priceBreakupOverlay');
  const sheet = document.getElementById('priceBreakupSheet');
  if (overlay && sheet) {
    overlay.classList.add('active');
    sheet.classList.add('active');
    document.body.classList.add('cartx-price-breakup-open');
  }
};

window.closePriceBreakup = function () {
  const overlay = document.getElementById('priceBreakupOverlay');
  const sheet = document.getElementById('priceBreakupSheet');
  if (overlay && sheet) {
    overlay.classList.remove('active');
    sheet.classList.remove('active');
    document.body.classList.remove('cartx-price-breakup-open');
  }
};

window.proceedToCheckout = function () {
  window.location.href = '/checkout';
};

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cartx-drawer-product-remove');
  if (!btn) return;

  const li = btn.closest('li');
  if (!li) return;

  const variantId = li.getAttribute('data-variant-id');
  if (!variantId) return;

  const currentQty = parseInt(li.querySelector('.cartx-drawer-product-quantity-input')?.value) || 1;

  const variantObject = {
    [variantId]: {
      quantity: currentQty,
      price: parseInt(li.getAttribute('data-price')) || 0,
      type: li.getAttribute('data-product-type') || '',
    },
  };

  if (typeof window.cartx === 'function') window.cartx(variantObject, 'REMOVE');
});

document.addEventListener('click', function (e) {
  if (!e.target.closest('.cartx-show-offers')) return;
  const panel = document.querySelector('.cartx-all-offers');
  if (panel) panel.classList.add('is--visible');
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cartx-drawer-product-quantity-button');
  if (!btn) return;

  const eventName = btn.getAttribute('name');
  if (eventName !== 'plus' && eventName !== 'minus') return;

  const li = btn.closest('li');
  if (!li) return;

  const variantId = li.getAttribute('data-variant-id');
  if (!variantId) return;

  const variantObject = {
    [variantId]: {
      quantity: parseInt(li.getAttribute('data-quantity')) || 0,
      price: parseInt(li.getAttribute('data-price')) || 0,
      type: li.getAttribute('data-product-type') || '',
    },
  };

  if (eventName === 'plus') {
    if (typeof window.cartx === 'function') window.cartx(variantObject, 'ADD');
  } else {
    if (typeof window.cartx === 'function') window.cartx(variantObject, 'REMOVE');
  }
});
